import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { ActivatedRoute, Router } from "@angular/router";

import { DespesaService } from '../services/despesa.service';
import { AuthService } from '../services/auth.service';
import { VeiculoService } from '../services/veiculo.service';
import { ExcelService } from '../services/excel.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';


@Component({
	selector: 'app-ipva',
	templateUrl: './ipva.component.html',
	styleUrls: ['./ipva.component.css'],
	animations: [loadingFade, modal, alert]
})
export class IpvaComponent implements OnInit {

    public menu_id = 152;

	public loading = false;
	public despesas = [];
	public veiculos = [];
	public cliente = [];
	public unidades = [];

	
	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;
	
	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
	
	constructor(private fb: FormBuilder,
				private despesaSvc: DespesaService,
				private authSvc: AuthService,
				private veiculoSvc: VeiculoService,
				private clienteSvc: ClienteService,
				private unidadeSvc: UnidadeService,	
				private router: Router,	
				private route: ActivatedRoute,									
				private excelSvc: ExcelService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  		

		this.pegaDespesas();
		this.criaFiltro();
		this.pegaVeiculos();
		this.pegaClientes();

	}

	criaFiltro() {
		this.formFiltro = this.fb.group({
			despesa_data_compra___data_i: null,
			despesa_data_compra___data_f: null,
			veiculo_id___veiculo_id: null,
			cliente_id___cliente_id: null,
			unidade_id___unidade_id: null,
			despesa_situacao__despesa_situacao: ''
		});

		let campos_data = ['despesa_data_compra___data_i', 'despesa_data_compra___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}

		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loCliente_id = null;
			  let loUnidade_id = null;
			  let loVeiculo_id = null;
			  let loData_i = "";
			  let loData_f = "";
			  let loValorMin = null;
			  let loValorMax = null;
			  let loSituacao = null;
	  
			  //his.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "cliente_id___cliente_id": { 
	  
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;
					  loCliente_id = parseInt(loSplitValor[1]);
					  this.pegaUnidadesFiltro(loSplitValor[1]);
					}
					 break; 
	  
				  } 
				  case "unidade_id___unidade_id": { 
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;	
					  loUnidade_id = parseInt(loSplitValor[1]);
					}
	  
					break; 
				  }
				  case "veiculo_id___veiculo_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						 loVeiculo_id = parseInt(loSplitValor[1]);
						 this.pegaVeiculosEProfissionalFiltro(loUnidade_id,loCliente_id);

					}
					 break; 
				  } 
				  case "despesa_data_compra___data_i": { 
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "despesa_data_compra___data_f": { 
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "despesa_situacao__despesa_situacao": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						loSituacao = loSplitValor[1];
					}
					break; 
				  }  				  			                                                        
				 }
	  
			  }
			  this.preencheForm({
				cliente_id___cliente_id: loCliente_id,
				unidade_id___unidade_id: loUnidade_id,
				veiculo_id___veiculo_id: loVeiculo_id,
				despesa_data_compra___data_i: loData_i,
				despesa_data_compra___data_f: loData_f,
				despesa_situacao__despesa_situacao: loSituacao								
	  
			  });
			  this.filtra();
	  
			}
	  
		  });	
		

	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
		}
	
	  pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
		  this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
			this.unidades = data;
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
			this.loading = false;
		  });
		}
	  }

	  pegaVeiculosEProfissionalFiltro(unidade_id,cliente_id){

		if(typeof unidade_id === 'undefined'){
		  return "";
		}else{
		this.loading = true;
		  this.veiculos = []
		  this.veiculoSvc.getByVeiculoUnidadeEspecialidade(unidade_id,"ambulancia").then((data: any[]) => {
	  
		  let dados = [];
		  for(let veiculo of data){
			dados.push({
			veiculo_id: veiculo.veiculo_id,
			placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
			unidade_id: unidade_id,
			cliente_id: cliente_id
			});
		  }
		  this.veiculos = dados;
	  
		  this.loading = false;
		  }).catch((err) => {
		  console.log(err);
		  });
		}
	  }	  	

	pegaDespesas() {

		this.despesas = [];
		this.loading = true;


		this.despesaSvc.getByDespesaAndTipoQtd(this.authSvc.getUsuarioId() ,3 ,this.filtro).then((qtde: any) => {
			this.count = qtde;
			
			this.despesaSvc.getByDespesaAndTipoConsulta(this.authSvc.getUsuarioId() ,3 ,this.filtro, this.page).then((data: any) => {
				this.despesas = data;
				this.loading = false;
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			})
			

		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})



		/*this.despesaSvc.getByUsuarioAndTipo(this.authSvc.getUsuarioId(),3).then((data: any) => {
			this.despesas = data;
			this.count = this.despesas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})*/
	}

	pegaVeiculos(){
		this.veiculos = [];
		this.loading = true;
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;

    	this.dadosFiltrados = new FiltroPipe().transform(this.despesas, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
		this.pegaDespesas();
	}

	apagaDespesa(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.despesaSvc.apagaDespesa(id).then((data) => {
					this.pegaDespesas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.despesas;
		}
		for(let index in this.dadosFiltrados){

			console.log(this.dadosFiltrados[index]);

			data[index] = {
				'Veículo': this.dadosFiltrados[index].veiculo_placa,
				'Planejado': this.dadosFiltrados[index].despesa_planejado == 'S' ? 'Sim' : 'Não',
				'Data': moment(this.dadosFiltrados[index].despesa_data_compra).format('DD/MM/YYYY'),
				'Valor': this.dadosFiltrados[index].despesa_valor.replace('.', ','),
				'Solicitante': this.dadosFiltrados[index].despesa_solicitante,
				'Aprovador': this.dadosFiltrados[index].despesa_aprovador,
				'Descrição': this.dadosFiltrados[index].despesa_descricao
			};
		}

		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Licenciamento e IPVA');
	}
	
	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.cliente = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  onChangeVeiculoUnidade(e){
		this.veiculos = []
		this.veiculoSvc.getByVeiculoClienteUnidade(e.unidade_id,e.cliente_id).then((data: any[]) => {

			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero
				});
			}

			this.veiculos = dados;


			  }).catch((err) => {
				  console.log(err);
			  });
	  }

	  onChangeClientes(e){
  		//this.formFiltro.controls.unidades.setValue(null);

		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			despesa_data_compra___data_i: null,
			despesa_data_compra___data_f: null,
			veiculo_id___veiculo_id: null,
			cliente_id___cliente_id: null,
			unidade_id___unidade_id: null,
			despesa_situacao__despesa_situacao: ''
		});
	  }	  


	  EditIpva(despesa_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/ipva/edit/' + despesa_id + params]);
	  }

}
